import { useLocation, useNavigate, useParams } from "react-router-dom";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { useEffect, useMemo, useState } from "react";
import { notification } from "antd";
import axiosInstance from "../../../../Services/axiosCommon";

import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { NuDate, NuInput, NuTextArea, NuTime } from "../../../../Components/Utils/Input";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import { BackButton, CancelButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import * as yup from 'yup';
import { useFormik } from "formik";
import FormikSelectTwo from "../../../../Components/Utils/Select";


const EditTask = ({}) => {
  const { value: taskpriority } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "taskpriority"
  );
  const { value: taskstatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "taskstatus"
  );
   const location = useLocation();
    const data = location.state.data;
       console.log(data, "taskstate");
   const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { taskEditId } = useParams();
  const [api, contextHolder] = notification.useNotification();
  const [image, setImage] = useState({ preview: "", raw: "" });
   const [membersAll,setMembersAll] =useState([]);
   const [isLoadingAllmembers,setLoadingAllmembers] = useState(false);
   const [createNew, setCreateNew] = useState({
   
    taskName: '',
    // taskTeam: "",
    assignedTo: [],
    copyTo: [],
    startDate:"",
    endDate: "",
    priority: "",
    noOfDays:"",
    noOfWeeks:"",
     taskStatus: "",
     
    reminderDate: "",
    reminderTime: "",
    taskDesc:"",
    completeDate:"",
   
    // projectId: "",
    // titleId:"",
    // severity: "",
   
    // attachment: "",
    // reAssignedTo:[],
   
    // isInstEnabled:false,
    // unit:"",
    // quantity:null,
    // today:null,
    // completed:null,
    // remaining:null,
    // actualCompleteDate:"",
    
   
  });
  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };
 

  const getAllMembers = async () => {
    setLoadingAllmembers(true);
    try {
      const response = await axiosInstance.get(`/tasks/member-drop-down`);
      
      if (response.data?.status && Array.isArray(response.data.data)) {
        const formattedMembers = response.data.data.map(member => ({
          value: member.id.toString(), 
          label: member.name
        }));
        setMembersAll(formattedMembers);
      }
    } catch (error) {
      console.error("Error fetching members:", error);
      setMembersAll([]);
    } finally {
      setLoadingAllmembers(false);
    }
  };
  
  
  useEffect(() => {
    
    getAllMembers();
    data &&
      setCreateNew({
        taskName: data?.taskName,
          assignedTo: data?.assignedTo?.map((i, k) => {
          return i?.userId;
        }),
        copyTo: data?.copyTo?.map((i, k) => {
          return (
            // i?.firstName
            i?.userId
          );
        }),
        priority: data?.priority,
        startDate: data?.startDate,
        endDate: data?.endDate,
        reminderDate: data?.reminderDate,
        reminderTime: data?.reminderTime,
        taskDesc:data?.taskDesc,
        taskStatus: data?.taskStatus,
        noOfDays:data?.noOfDays||null,
        noOfWeeks:data?.noOfWeeks||null,
        completeDate:data?.completeDate||""
      });
  }, []);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema: yup.object({
      taskName: yup.string().required("Task Name is Required"),
         startDate: yup.date().required("Start Date is Required"),
      endDate: yup.date()
        .required("Due Date is Required")
        .min(yup.ref('startDate'), "Due Date must be after Start Date"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      
      try {
        // Prepare form data
        const processedValues = {
          ...values,
          reminderDate: values.reminderDate === "None" ? "" : values.reminderDate,
          reminderTime: values.reminderTime === "None" ? "" : values.reminderTime,
          reAssignedTo: []
        };
  
        const formData = new FormData();
        formData.append("taskData", JSON.stringify(processedValues));
        if (image?.raw) {
          formData.append("attachment", image.raw);
        }
  
        // Determine API call based on edit/create mode
        const apiCall = taskEditId 
          ? axiosInstance.put(`/tasks/edit-task/${taskEditId}`, formData)
          : axiosInstance.post("/tasks/new-task", formData);
  
        const response = await apiCall;
  
        if (response.status === 200 || response.status === 201) {
          api.success({
            message: `Task ${taskEditId ? 'Updated' : 'Created'} successfully`,
            placement: "bottomRight",
          });
          navigate(-1);
          if (!taskEditId) resetForm();
        } else {
          throw new Error(response.data.msg || "Operation failed");
        }
      } catch (error) {
        console.error("API Error:", error);
        api.error({
          message: `Task ${taskEditId ? 'Update' : 'Creation'} failed`,
          description: error.response?.data?.msg || error.message || "Network error",
          placement: "bottomRight",
        });
      } finally {
        setIsLoading(false);
      }
    },
  });
  function diff_weeks(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60 * 60 * 24 * 7;
    //  let result = Math.abs(Math.round(diff));
    return Math.abs(Math.round(diff));
  }
  function DateDiff(createDate, expiryDate) {
    // createDate = new Date(createDate);
    // expiryDate = new Date(expiryDate);
    let timeDiff = Math.abs(expiryDate.getTime() - createDate.getTime());
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return diffDays == 0 ? diffDays + 1 : diffDays + 1;
  }
  useMemo(() => {
    if (formik.values.startDate && formik.values.endDate) {
      let startDate = new Date(formik.values.startDate);
      let endDate = new Date(formik.values.endDate);
      formik.values.noOFWeeks = diff_weeks(startDate, endDate);
      formik.values.noOFDays = DateDiff(startDate, endDate);
    }
  }, [formik.values.startDate, formik.values.endDate]);

  // useMemo(()=>{
  //   getMembers(formik.values.taskTeam)
  //   // formik.values.assignedTo = []
  // },[formik.values.taskTeam])
  return (
    <div className="px-4 py-2 h-full w-full overflow-hidden">
      <div className="flex justify-between">
      {contextHolder}
      <Breadcrumb
        items={[
          {
            name: "Task",
            // link: "tasks/my-task"
          },
          {
            name: "Edit",
           
          },
              ]}
      />
      <BackButton/>
      </div>
      {/* {
        (isLoadingAllmembers == true && isLoadingMembers == true && isLoadingTeams) ? ( */}
          {/* // <div className="w-full h-[85vh]  "> */}
          <form onSubmit={formik.handleSubmit}>
          <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
          <div className=" w-full h-full flex py-2 justify-start content-start flex-wrap  overflow-y-auto">
        
              <div className="w-full">
                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                Task Details :
                </p>
              </div>
              
              <NuInput
                           type="text"

                label="Task Name"
                placeholder="Task Name"
                formik={formik}
                name="taskName"
                width=" w-full md:w-[66%]"
                isRequired={true}
              />
            {/* <FormikSelectTwo
                label='Team'
                Options={team}
                formik={formik}
                placeholder='Choose'
                name='taskTeam'
                width='w-full md:w-1/3 md:-mt-2'
                isRequired={true}
              /> */}
              <MultiSelect
                label='Assignee'
                Options={membersAll}
                formik={formik}
                placeholder='Choose'
                name='assignedTo'
                width='w-full md:w-1/3 md:-mt-2'
              />
              <MultiSelect
                label="Copy To"
                Options={membersAll}
                formik={formik}
                placeholder="Choose"
                name="copyTo"
                width=" w-full md:w-1/3 md:-mt-2"
              />
              <NuDate
                label="Start Date"
                formik={formik}
                name="startDate"
                width=" w-full md:w-1/3 md:-mt-2"
                isRequired={true}
              />
              <NuDate
                label="Due Date"
                formik={formik}
                name="endDate"
                width=" w-full md:w-1/3 md:-mt-2"
                isRequired={true}
              />
              <FormikSelectTwo
                label="Priority"
                Options={taskpriority}
                formik={formik}
                placeholder="Choose"
                name="priority"
                width=" w-full md:w-1/3 md:-mt-2"
              />
            
  
              <NuInput
                           type="number"

                label="No.Week"
                placeholder="0"
                disable={true}
                formik={formik}
                name="noOFWeeks"
                width=" w-full md:w-1/3 md:-mt-2"
              />
              <NuInput
                           type="number"

                label="No.Days"
                placeholder="0"
                disable={true}
                formik={formik}
                name="noOFDays"
                width=" w-full md:w-1/3 md:-mt-2"
              />
              <FormikSelectTwo
                label="Task Status"
                Options={taskstatus}
                formik={formik}
                placeholder="Choose"
                name="taskStatus"
                width=" w-full md:w-1/3 md:-mt-2"
              />
              {/* <NuDate
                label="Revised End Date"
                formik={formik}
                name="revisedEndDate"
                width=" w-full md:w-1/3 md:-mt-2"
              /> */}
              <NuDate
                label="Reminder Date"
                formik={formik}
                name="reminderDate"
                width=" w-full md:w-1/3 md:-mt-2"
              />
              <NuTime
                label="Reminder Time"
                formik={formik}
                name="reminderTime"
                width=" w-full md:w-1/3 md:-mt-2"
              />

              <NuDate
                label="Actual Complete Date"
                formik={formik}
                name="actualCompleteDate"
                width=" w-full md:w-1/3 md:-mt-2"
              />

        <NuTextArea label="Description" placeholder="Enter Description" formik={formik} name="taskDesc" width=' w-full' />
  
            
             <div className="w-full hidden md:block mx-auto my-4 mt-8 ">
                          <div className="md:flex justify-end gap-4">
                          <CancelButton handleClick={() => navigate(-1)} />
          
                            <SubmitButton isLoading={isLoading} />
                          </div>
                        </div>
  </div>
  </div>

          </form>
        
       

    </div>
  );
};

export default EditTask;
